module.exports = __webpack_public_path__ + "source/img/robot-wave.6a5fdf48.png";